class MemberSearchMap {
  constructor(div) {
    this.mapDiv = document.querySelector(div);
    this.data = this.mapDiv.getAttribute('data-js-map-data');
    this.markerPath = this.mapDiv.getAttribute('data-js-map-marker');
    this.clusterMarkerPath1 = this.mapDiv.getAttribute('data-js-map-cluster-marker-1');
    this.clusterMarkerPath2 = this.mapDiv.getAttribute('data-js-map-cluster-marker-2');
    this.clusterMarkerPath3 = this.mapDiv.getAttribute('data-js-map-cluster-marker-3');
    this.clusterMarkerPath4 = this.mapDiv.getAttribute('data-js-map-cluster-marker-4');
    this.clusterMarkerPath5 = this.mapDiv.getAttribute('data-js-map-cluster-marker-5');
    const key = this.mapDiv.getAttribute('data-js-map-key');

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMemberMap`;
    script.defer = true;
    document.head.appendChild(script);

    window.initMemberMap = function() {
      window.memberSearchMap.init();
    }
  }

  init() {
    const map = new google.maps.Map(
      this.mapDiv,
      {
        zoom: 1,
        minZoom: 1,
        maxZoom: 16,
        center: {
          lat: 53.891417,
          lng: -1.765455
        },
        mapTypeId: 'roadmap',
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          mapTypeIds: ['roadmap', 'satellite', 'hybrid'],
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        scaleControl: true,
        streetViewControl: true,
        zoomControl: true,
        rotateControl: true,
        fullscreenControl: true,
        styles: [
          { elementType: 'geometry', stylers: [{ "saturation": -100 }]},
          { elementType: 'labels.text.stroke', stylers: [{ "saturation": -100 }]},
          { elementType: 'labels.text.fill', stylers: [{ "saturation": -100 }]},
        ]
      }
    );

    // Create empty array to hold each marker
    let markerArray = [];

    const icon = {
      url: this.markerPath,
      size: new google.maps.Size(50, 75),
      scaledSize: new google.maps.Size(50, 75),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 75)
    }

    const bounds = new google.maps.LatLngBounds();

    JSON.parse(this.data).forEach(function(address, i) {
      if (address.latitude === null || address.longitude === null) {
        return;
      }

      const latLng = {
        lat: Number.parseFloat(address.latitude),
        lng: Number.parseFloat(address.longitude)
      };

      const marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: (icon)
      });

      // Send current marker to markerArray
      // So we can add a clusterer to it later
      markerArray.push(marker);

      const infoWindow = new google.maps.InfoWindow({
        content: `
        <div class="map__infowindow">
          <p>${ address.company_name }</p>
          <p>${ address.address1 }</p>
          <p>${ address.address2 }</p>
          <p>${ address.address3 }</p>
          <p>${ address.city }</p>
          <p>${ address.postcode }</p>
        </div>
        `
      });

      marker.addListener('click', function() {
        infoWindow.open(map, marker);
      });

      bounds.extend(latLng);
    });

    const markerClusterOptions = {
      // imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
      maxZoom: 14, // Don't cluster markers at max zoom level
      styles: [
        {
          anchorIcon: [0, 0],
          anchorText: [19, 0],
          textSize: 12,
          textColor: "black ",
          textDecoration: "none",
          fontStyle: "normal",
          // fontFamily: "Arial, sans-serif",
          fontWeight: "bold",
          backgroundPosition: "0 0",
          height: 52,
          width: 53,
          url: this.clusterMarkerPath1,
        },
        {
          anchorIcon: [0, 0],
          anchorText: [21, 0],
          textSize: 12,
          textColor: "black ",
          textDecoration: "none",
          fontStyle: "normal",
          // fontFamily: "Arial, sans-serif",
          fontWeight: "bold",
          backgroundPosition: "0 0",
          height: 55,
          width: 56,
          url: this.clusterMarkerPath2,
        },
        {
          anchorIcon: [0, 0],
          anchorText: [26, 0],
          textSize: 12,
          textColor: "black ",
          textDecoration: "none",
          fontStyle: "normal",
          // fontFamily: "Arial, sans-serif",
          fontWeight: "bold",
          backgroundPosition: "0 0",
          height: 65,
          width: 66,
          url: this.clusterMarkerPath3,
        },
        {
          anchorIcon: [0, 0],
          anchorText: [31, 0],
          textSize: 14,
          textColor: "black ",
          textDecoration: "none",
          fontStyle: "normal",
          // fontFamily: "Arial, sans-serif",
          fontWeight: "bold",
          backgroundPosition: "0 0",
          height: 77,
          width: 78,
          url: this.clusterMarkerPath4,
        },
        {
          anchorIcon: [0, 0],
          anchorText: [35, 0],
          textSize: 16,
          textColor: "black ",
          textDecoration: "none",
          fontStyle: "normal",
          // fontFamily: "Arial, sans-serif",
          fontWeight: "bold",
          backgroundPosition: "0 0",
          height: 89,
          width: 90,
          url: this.clusterMarkerPath5,
        }
      ]
    }

    // Add a marker clusterer to manage the markers.
    new MarkerClusterer(map, markerArray, markerClusterOptions);

    map.fitBounds(bounds);
  }
}

export default MemberSearchMap
